var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96582 17C4.63587 17 2.74707 15.0572 2.74707 12.6607C2.74707 10.686 3.99213 9.27551 5.74707 8.75C6.03544 7.64488 6.63855 6.34426 7.48168 5.47703C10.0445 2.84099 14.1996 2.84099 16.7625 5.47703C18.0523 6.80374 18.8806 8.51115 18.8721 10.25C20.4622 10.4839 21.4971 11.9247 21.4971 13.625C21.4971 15.489 20.028 17 18.2158 17",
    stroke: "#C1C7D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7471 13.95L12.4971 11.75M12.4971 11.75L10.2471 13.95M12.4971 11.75V20",
    stroke: "#C1C7D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b1dfa49c3588d2662c47cff7050f21a8.svg";
export { ForwardRef as ReactComponent };